/* Riusa gli eventi Focal; una sola lettura condivisa se cart:refresh non ha dati. */
(() => {
  if (customElements.get('extro-shipping-service')) return;
  const rows = new Set();
  let latestCart, pending, revision = 0;
  function accept(cart) {
    if (!cart || !Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count)) return;
    revision++;
    latestCart = cart;
    rows.forEach(row => row.update(cart));
  }
  function refresh() {
    if (pending || !rows.size) return;
    const started = revision;
    const root = window.Shopify?.routes?.root || '/';
    pending = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(response => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(cart => { if (revision === started) accept(cart); })
      .catch(() => {}) // Un errore di rete conserva il testo gia' corretto.
      .finally(() => { pending = null; });
  }
  function onCart(event) { if (event.detail?.cart) accept(event.detail.cart); else refresh(); }
  function onReturn(event) { if (event.type === 'pageshow' ? event.persisted : !document.hidden) refresh(); }
  class ShippingService extends HTMLElement {
    connectedCallback() {
      if (!rows.size) {
        document.addEventListener('cart:updated', onCart);
        document.addEventListener('cart:refresh', onCart);
        document.addEventListener('visibilitychange', onReturn);
        window.addEventListener('pageshow', onReturn);
      }
      rows.add(this);
      if (latestCart) {
        this.update(latestCart);
        if (!this.querySelector('[data-shipping-title]')) {
          this.readyFrame = requestAnimationFrame(() => { if (this.isConnected && latestCart) this.update(latestCart); });
        }
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.readyFrame);
      rows.delete(this);
      if (!rows.size) {
        document.removeEventListener('cart:updated', onCart);
        document.removeEventListener('cart:refresh', onCart);
        document.removeEventListener('visibilitychange', onReturn);
        window.removeEventListener('pageshow', onReturn);
      }
    }
    update(cart) {
      const threshold = Number(this.dataset.threshold);
      const currency = this.dataset.currency;
      const comparable = !cart.currency || cart.currency === currency;
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
      }).format(cents / 100);
      const label = this.dataset.thresholdLabel;
      let title = `Spedizione gratis da ${label}`, note = this.dataset.emptyNote || '';
      if (comparable && cart.item_count > 0) {
        if (cart.total_price >= threshold) {
          title = 'Spedizione gratis';
          note = `Gli ordini da ${label} hanno la spedizione gratuita.`;
        } else {
          note = `Ti mancano solo ${format(threshold - cart.total_price)}, completa il tuo outfit per ottenere la spedizione gratuita.`;
        }
      }
      if (this.dataset.mode === 'purchase') {
        title = `Spedizione gratuita da ${label} · Standard ${this.dataset.standardLabel}`;
        note = this.dataset.emptyNote || '';
        if (comparable && cart.item_count > 0) {
          title = cart.total_price >= threshold ? 'Spedizione gratuita!' : `Mancano ${format(threshold - cart.total_price)} per la spedizione gratuita!`;
        }
      }
      for (const [selector, value] of [['[data-shipping-title]', title], ['[data-shipping-note]', note]]) {
        const node = this.querySelector(selector);
        if (node && node.textContent.trim() !== value) node.textContent = value;
      }
    }
  }
  customElements.define('extro-shipping-service', ShippingService);
})();
